import type { DashboardAnalytics } from '@library/api-customer-engagement-experience'
import { queueTrackingEvent } from '@library/tracking-integration'

// Forwards a server-provided analytics descriptor straight to Snowplow. A missing
// descriptor is a safe no-op so an un-instrumented action never breaks the click.
export const trackAction = (analytics?: DashboardAnalytics) => {
  if (!analytics) return

  queueTrackingEvent<DashboardAnalytics>(analytics)
}

// The xAPI sends one carousel action used in two places. Analytics needs distinct
// action values for a tile click vs the "View all" header, so the client overrides
// it here. TODO(v2): have the xAPI send recipe_click and recipe_view_all separately.
export const trackRecipeCarousel = (
  analytics: DashboardAnalytics | undefined,
  { isTileClick }: { isTileClick: boolean },
) => {
  if (!analytics) return

  queueTrackingEvent<DashboardAnalytics>(
    isTileClick ? { ...analytics, action: 'recipe_click' } : analytics,
  )
}

// Slot-save fires on mutation success. The xAPI supplies order_id and the original
// slot id; the client fills new_deliveryslot_id from the selected slot id.
export const trackSlotSaved = (
  analytics: DashboardAnalytics | undefined,
  { newSlotId }: { newSlotId: string },
) => {
  if (!analytics) return

  queueTrackingEvent<DashboardAnalytics>({
    ...analytics,
    properties: { ...analytics.properties, new_deliveryslot_id: newSlotId },
  })
}
